import { VisuallyHidden } from '@overdose/components'
import { IconArrowRight } from '@tabler/icons-react'
import classNames from 'classnames'
import { CategoryCardOverlayLink } from '~/components/CategoryCardOverlayLink'

import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './SimpleCategoryCard.module.scss'
import { SimpleCategoryCardProps } from './SimpleCategoryCard.types'

export const SimpleCategoryCard = ({
  image,
  title,
  action,
  isDesktopCarouselDisabled,
  categorySku,
  width,
}: SimpleCategoryCardProps) => {
  return (
    <div
      className={classNames(
        styles.card,
        width === 'super-narrow' && styles.superNarrowCard,
        isDesktopCarouselDisabled && styles.desktopCarouselDisabledCard,
        'p-2 relative overflow-hidden'
      )}>
      <CategoryCardOverlayLink
        url={action?.url}
        sku={categorySku}
        title={title}
      />
      <div
        className={classNames(
          styles.cardImage,
          'relative rounded-md',
          'bg-cover bg-center'
        )}
        style={{
          backgroundImage: `url(${image.src})`,
        }}>
        {action && !action.url.startsWith('/url/') && (
          <div
            className={classNames(
              'absolute lg:bottom-6 bottom-4 py-2 px-4 bg-white rounded',
              styles.actionContainer,
              {
                'lg:right-6 right-4': action.buttonPosition === 'right',
                'lg:left-6 left-4': action.buttonPosition !== 'right',
              }
            )}>
            <Typography
              tag={TypographyTag.span}
              variant={TypographyVariant.BodyRegularBold}
              className='text-primary-heading'>
              {action.linkText}
            </Typography>
            <IconArrowRight
              size={20}
              color='var(--btn-solid-color-text-secondary)'
              strokeWidth={2}
              className={classNames('inline-block', {
                'ml-2': !!action.linkText,
              })}
            />
            <VisuallyHidden>Browse {title}</VisuallyHidden>
          </div>
        )}
      </div>
      <Typography
        tag={TypographyTag.div}
        variant={TypographyVariant.BodyRegular}
        className={classNames(
          styles.title,
          'relative z-[1] mt-4',
          '!text-primary-blue !font-semibold text-center',
          '!text-sm lg:!text-[18px]'
        )}>
        {title}
      </Typography>
    </div>
  )
}
